module.exports = __webpack_public_path__ + "media/images/icons/hands-089cce32dd60245aee20c5a6630cdbce.svg";